export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_BUTTON_STATE_LOADING':
      return {
        ...state,
        [action.key]: true,
      };
    case 'SET_BUTTON_STATE_LOADED': {
      // eslint-disable-next-line no-unused-vars
      const { [action.key]: value, ...withoutKey } = state;
      return withoutKey;
    }
    default:
      return state;
  }
};
